module.exports = __webpack_public_path__ + "static/img/格里森弧齿锥齿轮的计算.e73ff98a.jpg";